/**
 * Lightweight fetch hook for catalogue data with graceful fallback to local
 * mock data. Pattern: try the live API first; if it fails (network, 5xx, etc.)
 * fall back to the static mockData so the site never breaks.
 */

import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const logDev = (label, err) => {
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.warn(label, err);
  }
};

export const useCatalogueResource = (path, fallback) => {
  const [data, setData] = useState(fallback);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    axios
      .get(`${API_URL}${path}`)
      .then((res) => {
        if (!cancelled && res.data) setData(res.data);
      })
      .catch((err) => {
        logDev(`Falling back to local data for ${path}:`, err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [path]);

  return { data, loading };
};
